import React, {ReactNode} from 'react'
import styled from '@emotion/styled'

import {Card} from '@vio/atlas/Card'
import {Box} from '@vio/atlas/helpers/Box'
import {Tag, TagSize} from '@vio/atlas/Tag'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

type Gap = keyof typeof cssTheme.layout.spacing

const TransparentCard = styled(Card)`
  background: transparent;
`
const Heading = styled.div<{gap: Gap}>`
  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;
  gap: ${({gap}) => cssTheme.layout.spacing[gap]};
`

const HeadingTitle = styled.div`
  flex: 0 0 auto;
  max-width: 100%;
`

const HeadingTag = styled.div`
  flex: 0 0 auto;
  white-space: nowrap;
`

const EndSlot = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`

interface Props {
  dataId?: string
  title: ReactNode
  tagLabel: ReactNode
  children: ReactNode
  endSlot?: ReactNode
  tagSize?: TagSize
  headingGap?: Gap
  contentGap?: Gap
}

export const DealFreezeBannerCard: React.FC<Props> = ({
  dataId,
  title,
  tagLabel,
  children,
  endSlot,
  tagSize = 'sm',
  headingGap = 's250',
  contentGap = 's250'
}) => (
  <TransparentCard
    dataId={dataId}
    borderRadius="lg"
    borderColorPath="border.neutral.secondary"
  >
    <Box display="flex" alignItems="center" gap="s300" padding="s400">
      <Box
        display="flex"
        flexDirection="column"
        gap={contentGap}
        flexGrow="1"
        minWidth="0"
      >
        <Heading gap={headingGap}>
          <HeadingTitle>
            <Text variant="titleS">{title}</Text>
          </HeadingTitle>
          <HeadingTag>
            <Tag variant="brand" size={tagSize}>
              {tagLabel}
            </Tag>
          </HeadingTag>
        </Heading>
        <Text variant="bodyXS" colorPath="content.neutral.secondary">
          {children}
        </Text>
      </Box>
      {endSlot && <EndSlot>{endSlot}</EndSlot>}
    </Box>
  </TransparentCard>
)
